export const roles = {
  dealership: 'dealership',
  user: "customer",
  company: "company",
};
